import { IPlanificationProgressChart } from '@sdk/contracts';
import { useTranslation } from 'react-i18next';

import { ProgressTipWrapper } from './ProgressTip.styles';

import { Icon } from '@/components/Icon';

type Props = {
  planificationProgress: IPlanificationProgressChart;
};

export const ProgressTip: React.FC<Props> = ({ planificationProgress }) => {
  const { t } = useTranslation('StudentDashboardTranslations');

  const getMessage = () => {
    const diff = planificationProgress.idealProgress - planificationProgress.currentProgress;

    if (planificationProgress.currentProgress.toFixed(0) === '0') {
      return t('NOT_STARTED_PROGRESS_TIP');
    }

    if (diff < 0) {
      return t('EXCEEDED_PROGRESS_TIP', { percentage: Math.abs(diff).toFixed(0) });
    }
    if (diff === 0) {
      return t('ON_TIME_PROGRESS_TIP');
    }
    if (diff <= 10) {
      return t('BIT_LATE_PROGRESS_TIP');
    }
    return t('LATE_PROGRESS_TIP');
  };

  return (
    <ProgressTipWrapper>
      <Icon i="Information" size={14} color={'black9'} />
      <span>{getMessage()}</span>
    </ProgressTipWrapper>
  );
};
